import { fontFamily } from './constants';
const styleOverrides = {
    root: Object.assign({}, fontFamily),
};
export const MuiMenuItem = {
    styleOverrides,
};
